// @flow

export default function partnerUrl() {
  return '/start'
}
